import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { IntervalBarChart } from '@common/charts/interval-bar-chart/interval-bar-chart';
import styles from './statistics-widget.css';
export function StatisticsWidgetBarChart(props) {
    const { className, ...rest } = props;
    return _jsx(IntervalBarChart, { ...rest, className: classNames(styles.chart, className) });
}
